module.exports = __webpack_public_path__ + "static/media/cardSeventy.759be6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowOne/cardSeventy.jpg
// module id = 69
// module chunks = 0